import { Actions, thunk } from 'easy-peasy';
import { sortByName, teamMemberMapper } from '~/utils/clientAllocation';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkGetAllocationTeamMembers } from '../types';

const onGetAllocationTeamMembers: IThunkGetAllocationTeamMembers = thunk(
  async ({ setAllocationTeamMembers }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, actTeamId } = payload;

    const data = await api.actTeamMember
      .getActTeamMemberList(clinicId, actTeamId)
      .then(r => r.data);

    setAllocationTeamMembers((data || []).sort(sortByName).map(teamMemberMapper));
  },
);

export default onGetAllocationTeamMembers;
